const defaultState = {
  windowLevelData: {
    1: { description: 'Abdomen', window: '400', level: '60' },
    2: { description: 'Angio', window: '600', level: '300' },
    3: { description: 'Bone', window: '1500', level: '300' },
    4: { description: 'Brain', window: '80', level: '40' },
    5: { description: 'Chest', window: '400', level: '40' },
    6: { description: 'Lungs', window: '1500', level: '-400' },
    7: { description: '', window: '', level: '' },
    8: { description: '', window: '', level: '' },
    9: { description: '', window: '', level: '' },
    10: { description: '', window: '', level: '' },
  },
  generalPreferences: {
    // language: 'en-US'
  },
};

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_USER_PREFERENCES': {
      return Object.assign({}, state, action.state);
    }
    default:
      return state;
  }
};

export { defaultState };
export default preferences;
